import header from './header/header'
import indicatorList from './indicator/list'

/**
 * Atoms functions.
 */
export default function atoms() {
  header()
  indicatorList()
}